
<template>
  <main class="w-100">

    <!-- HERO SECTION -->
<div class="hero-section position-relative" style="height:100vh; overflow:hidden;">
  <img src="@/assets/images/mainlanding.png" alt="Hero" 
       style="width:100%; height:100%; object-fit:cover;">

  <!-- Black overlay -->
  <div class="overlay"></div>

  <!-- Hero content -->
  <div class="hero-overlay position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-start p-5" style="z-index: 2;">
    <h1 class="text-white fw-bold text-uppercase">Corporate Overview</h1>
    <p class="text-white fs-5">Kenali Bagaimana Kami Selalu Siap Membantu Transformasi Bisnis Anda</p>
    <button class="btn btn-orange rounded-pill text-uppercase fw-bold px-4 py-2 mt-3">Business Inquiries</button>
  </div>

  <!-- Satellite (behind text, but above background) -->
  <img src="@/assets/images/satellite.png" class="satellite" alt="Satellite">
</div>


    <!-- ABOUT COMPANY (ORANGE BG) -->
    <section class="about-orange py-5">
      <div class="container">
        <p class="lead text-white mb-0">
          Selama lebih dari satu dekade, <b>Skyreach</b> sebagai penyelenggara jaringan telekomunikasi berbasis satelit,
          dengan izin Jaringan Tetap Tertutup VSAT yang dikeluarkan oleh Kementerian Komunikasi dan Informatika. 
          Layanan <b>Skyreach</b> mencakup nasional dan internasional, dimana layanan yang diberikan dapat digunakan oleh berbagai industri 
          seperti maritim, penerbangan, energi & sumber daya alam, media penyiaran, operator telekomunikasi dan pemerintah.
        </p>
      </div>
    </section>

    <!-- HOW WE HELP -->
    <section class="py-5">
      <div class="container">
        <h6 class="text-uppercase text-start mb-4">
          <i class="fas fa-circle me-2 text-orange"></i>
          <b class="text-blue">Cara Kami Membantu Anda</b>
        </h6>
        <p>
          <b>Skyreach</b> memberi solusi telekomunikasi berkualitas untuk aplikasi data/internet, audio & video, 
          menjangkau darat, laut, dan udara. Kami berinovasi melalui teknologi informasi dan infrastruktur telekomunikasi
          untuk mendukung operasional bisnis: data center, <i>cloud</i>, GPS Tracking, hingga plantation.
        </p>
      </div>
    </section>

    <!-- TIMELINE -->
<section class="steps-success text-white py-5 position-relative">
  <!-- background image pagan -->
  <div class="steps-bg position-absolute top-0 start-0 w-100 h-100"></div>
  
  <div class="container position-relative">
    <h6 class="text-uppercase text-start mb-4">
      <i class="fas fa-circle me-2 text-orange"></i>
      <b class="text-white">Steps Toward Success</b>
    </h6>

    <div class="d-flex flex-wrap justify-content-center gap-5 mt-20">

      <!-- Timeline items -->
      <div class="timeline-item text-center animate-on-scroll " data-index="0">
        <div class="timeline-circle">
          <span class="timeline-year">2012-2013</span>
        </div>
        <p class="timeline-desc mt-3">
          Established & started to provide SCPC VSAT. 140 Maluku sites 105 Mobile VSAT
        </p>
      </div>

      <div class="timeline-item text-center animate-on-scroll" data-index="1">
        <div class="timeline-circle">
          <span class="timeline-year">2016</span>
        </div>
        <p class="timeline-desc mt-3">
          Launched SNG & Portable VSAT service for Broadcasting
        </p>
      </div>

      <div class="timeline-item text-center animate-on-scroll" data-index="2">
        <div class="timeline-circle">
          <span class="timeline-year">2017</span>
        </div>
        <p class="timeline-desc mt-3">
          <i><b>SAILINK®</b></i> Satellite communication Service started for maritime
        </p>
      </div>

      <div class="timeline-item text-center animate-on-scroll" data-index="3">
        <div class="timeline-circle">
          <span class="timeline-year">2018</span>
        </div>
        <p class="timeline-desc mt-3">
          Rewarded to host High Throughput Satellite (HTS) gateway for Telstar 18V in Indonesia
        </p>
      </div>

      <div class="timeline-item text-center animate-on-scroll" data-index="4">
        <div class="timeline-circle">
          <span class="timeline-year">2019</span>
        </div>
        <p class="timeline-desc mt-3">
          Integrating Phase-array SoTM & VSAT Hub with Heimdall defence for Indonesian Police
        </p>
      </div>

      <div class="timeline-item text-center animate-on-scroll" data-index="5">
        <div class="timeline-circle">
          <span class="timeline-year">2020-2025</span>
        </div>
        <p class="timeline-desc mt-3">
          Develops several technologies and products such as SAILINK® Navigator+, Sailogger, Sailormate, Mobile Nav+, SkyFlix, Skychat, Sailtrack Lite & Soilogger
        </p>
      </div>

    </div>
  </div>
</section>



  </main>
</template>


<script src="@/assets/js/about.js"></script>